<div #notchOverlayEl class="notch-overlay"></div>
<router-outlet></router-outlet>
@if (showTranslationKeyToggle) {
  <app-translation-key-toggle></app-translation-key-toggle>
}
<app-maintenance></app-maintenance>
<app-loading-toast></app-loading-toast>
<lib-session-context-status-banner></lib-session-context-status-banner>